import styled from "styled-components"

export const Main = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
`

export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }

  iframe {
    width: 100%;
    border: none;
    aspect-ratio: 16/9;
  }
`
